export interface ICustomerBaseData {
  first_name?: string
  email?: string
}

export interface ICustomerData extends ICustomerBaseData {
  readonly id?: number
}

export interface ICustomerBase extends ICustomerBaseData {
  // own fields
  validate(): boolean
}

export interface ICustomer extends ICustomerData, ICustomerBase {
  // own fields
  validate(): boolean
}

export const CUSTOMER_FIRST_NAME_MAX_LENGTH = 50;
export const CUSTOMER_EMAIL_MAX_LENGTH = 50;
